import type { TaskStatus } from '../types/taskRequest';

interface TaskStatusBadgeProps {
  status: TaskStatus;
  display?: string;
}

const statusConfig: Record<TaskStatus, { label: string; className: string }> = {
  New: { label: 'New', className: 'task-status-badge task-status-new' },
  InProgress: { label: 'In Progress', className: 'task-status-badge task-status-inprogress' },
  Completed: { label: 'Completed', className: 'task-status-badge task-status-completed' },
  Rejected: { label: 'Rejected', className: 'task-status-badge task-status-rejected' },
};

export default function TaskStatusBadge({ status, display }: Readonly<TaskStatusBadgeProps>) {
  const config = statusConfig[status] ?? statusConfig.New;
  return (
    <span className={config.className}>
      {display ?? config.label}
    </span>
  );
}
